var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-4 is-light"},[_c('b-field',{attrs:{"label":"Select a day"}},[_c('b-datepicker',{attrs:{"value":_vm.value,"show-week-number":false,"locale":"en-GB","icon-pack":"fas","icon":"calendar","placeholder":"Click to select...","trap-focus":""},on:{"input":e => _vm.$emit('input', e)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }